<template>
  <div class="px-10">
    <div class="text-h5 my-4 text-center">Actualiza a la versión completa</div>
    <p class="text-center">Convierte tu TPV en la central de gestión de tu restaurante por tan solo {{ $store.state.purchase.price }} € al mes.</p>
    <h-purchase-btn />

    <div class="text-h5 my-4 text-center">¿Qué podré hacer con la versión completa?</div>

    <v-img src="/i/purchase1.png" />
    <div class="text-h6 my-4">Utilizar mis propios productos</div>
    <p>Deja atrás el “modo simulación”. Carga tus propios productos y precios para poder hacer rodar tu negocio.</p>

    <v-img src="/i/purchase2.png" class="mt-12" />
    <div class="text-h6 my-4">Cobrar con tarjeta</div>
    <p>Cobra con tarjeta y cierra el pedido desde el mismo dispositivo. La venta se registrará simultáneamente tanto en tu TPV como en tu app.</p>

    <v-img src="/i/purchase3.png" class="mt-12" />
    <div class="text-h6 my-4">Registrar también el efectivo</div>
    <p>Anota todos tus cobros y asócialos a tus productos. También en efectivo o con métodos de pago especiales (cheques restaurante, tarjetas regalo, etc.).</p>

    <v-img src="/i/purchase4.png" class="mt-12" />
    <div class="text-h6 my-4">Acceder a mi back-office</div>
    <p>Administra tu negocio y configura tu app con tu panel de control:</p>
    <ul>
      <li>Edita tus productos y precios.</li>
      <li>Crea cuentas para diferentes empleados.</li>
      <li>Accede a los informes y las estadísticas de tu negocio.</li>
    </ul>
    <p class="mt-4">¡y mucho más!</p>

    <v-alert text type="info">
      <div class="font-weight-black">Recomendación</div>
      <div class="text-body-2">Para una mayor comodidad y un óptimo aprovechamiento de la herramienta, accede al back-office desde un ordenador.</div>
    </v-alert>
  </div>
</template>

<script>
  // import I18n from '@/Mixins/I18n'
  import HPurchaseBtn from '../PurchaseBtn'

  export default {
    mixins: [
      // I18n,
    ],

    components: {
      HPurchaseBtn,
    },

    async mounted () {
      const email = this.$page.props.auth.email ?? ''
      const fuc = await Bridge.interfaces.AndroidPayment.fuc()
      this.$store.dispatch('purchase/init', { email, fuc })
    },
  }
</script>
